/** biome-ignore-all lint/security/noDangerouslySetInnerHtml: <explanation> */

/** CMS rich text retains theme typography and restores semantic list styling. */
export default function HtmlMarkup({
	markup,
	className,
}: {
	markup?: string;
	className?: string;
}) {
	if (!markup) return null;

	return (
		<div
			className={className ? `rich-text ${className}` : "rich-text"}
			dangerouslySetInnerHTML={{ __html: markup }}
		/>
	);
}
